import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "name__container" }
const _hoisted_2 = { class: "name__label" }
const _hoisted_3 = { class: "name__value" }
const _hoisted_4 = { class: "detail__container" }
const _hoisted_5 = { class: "detail__item" }
const _hoisted_6 = { class: "detail__label" }
const _hoisted_7 = { class: "detail__value" }
const _hoisted_8 = { class: "detail__item" }
const _hoisted_9 = { class: "detail__label" }
const _hoisted_10 = { class: "detail__value" }
const _hoisted_11 = { class: "detail__item" }
const _hoisted_12 = { class: "detail__label" }
const _hoisted_13 = { class: "detail__value" }
const _hoisted_14 = { class: "detail__item" }
const _hoisted_15 = { class: "detail__label" }

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupInfoSection',
  props: {
    orderGroupName: {},
    numberOfOrder: {},
    upperLimitQuantity: {},
    afterUpperLimitQuantity: { default: undefined },
    totalAmount: {},
    afterTotalAmount: { default: undefined },
    hasBackground: { type: Boolean, default: true }
  },
  setup(__props: any) {

const t = i18n.t;
const props = __props;

const upperLimitQuantityView = computed(() =>
  props.upperLimitQuantity
    ? props.afterUpperLimitQuantity
      ? `${props.upperLimitQuantity.addComma()}→${props.afterUpperLimitQuantity.addComma()}`
      : props.upperLimitQuantity.addComma()
    : 0
);

const totalAmountView = computed(() =>
  props.totalAmount
    ? props.afterTotalAmount
      ? `${props.totalAmount.addComma()}→${props.afterTotalAmount.addComma()}`
      : props.totalAmount.addComma()
    : 0
);

const loadFactor = computed(() => {
  if (props.totalAmount === undefined || props.upperLimitQuantity === undefined) {
    return 0;
  }
  return ((props.afterTotalAmount ?? props.totalAmount) * 100) / (props.afterUpperLimitQuantity ?? props.upperLimitQuantity);
});

const isLoadFactorOverLimit = computed(() => (loadFactor.value ?? -1) > 100);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-group-info__container", { 'order-group-info__container--background': props.hasBackground }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('発注グループ名')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.orderGroupName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('発注件数')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(props.numberOfOrder), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('上限数量')), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(upperLimitQuantityView.value), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('発注合計数量')), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(totalAmountView.value), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('積載率')), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["detail__value", { 'detail__value--error': isLoadFactorOverLimit.value }])
        }, _toDisplayString(`${loadFactor.value.roundToDecimal(1)}%`), 3)
      ])
    ])
  ], 2))
}
}

})